import cx from 'classnames';

import { Icon } from '../../common/components';
import { CATEGORY_ICON_SET } from '../config/issueConfig';

interface IssueCategoryIconPickerProps {
  value: string;
  onChange: (icon: string) => void;
}

/** Výběr ikony kategorie – grid 4×4 z fixního setu (odpovídá BE whitelistu). */
export const IssueCategoryIconPicker: React.FC<IssueCategoryIconPickerProps> = ({ value, onChange }) => (
  <div className="IssueIconPicker">
    {CATEGORY_ICON_SET.map((icon) => (
      <button
        key={icon}
        type="button"
        className={cx('IssueIconPicker__item', value === icon && 'IssueIconPicker__item--active')}
        onClick={() => onChange(icon)}
        aria-label={icon}
      >
        <Icon name={icon} />
      </button>
    ))}
  </div>
);

export default IssueCategoryIconPicker;
